import React from 'react';

import FilterListItem from './FilterListItem';

import scss from './ColumnFilter.module.scss';

function FilterList({ options, selectedOptions, maxWidth, minWidth, onSelect, type }) {
  const handleSelect = (selectedOption) => {
    onSelect(selectedOption);
  };

  return (
    <ul className={scss['filter-list']} style={{ maxWidth, minWidth }}>
      {options.map((option) => (
        <FilterListItem
          key={option.id}
          option={option}
          onSelect={handleSelect}
          type={type}
          selectedOptions={selectedOptions}
        />
      ))}
    </ul>
  );
}

export default FilterList;
